// src/components/Charts/AssetsChart.js

import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import api from '../../../../api';

const AssetsChart = () => {
  const [series, setSeries] = useState([0, 0]);
  const [availableAssetsCount, setAvailableAssetsCount] = useState(0);
  const [assignedAssetsCount, setAssignedAssetsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAssetData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.get('/current-capacity-usage', {
        params: { asset_id: 1 }, // change if asset is dynamic
      });

      const { avilableAssetsCount, assignedAssetsCount } = response.data;

      const available = avilableAssetsCount || 0;
      const assigned = assignedAssetsCount || 0;

      setAvailableAssetsCount(available);
      setAssignedAssetsCount(assigned);
      setSeries([available, assigned]);
    } catch (err) {
      console.error(err);
      setError('Failed to fetch asset data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetData();
  }, []);

  const options = {
    labels: ['Available', 'Assigned'],
    chart: {
      type: 'donut',
      height: '100%',
      width: '100%',
      fontFamily: 'Plus Jakarta Sans, sans-serif',
      foreColor: '#adb0bb',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '85%',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '16px',
              fontWeight: 600,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: '14px',
              fontWeight: 500,
              offsetY: 10,
              formatter: function (val) {
                return val + '%';
              },
            },
            total: { show: false },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: false },
    legend: { show: false },
    colors: ['#11DEB9', '#FA9479'],
    tooltip: {
      theme: 'dark',
      fillSeriesColor: false,
    },
  };

  return (
    <div className="text-center">
      <div id="assets-chart" className="w-full h-64 flex items-center justify-center">
        {loading ? (
          <span>Loading...</span>
        ) : error ? (
          <span className="text-red-500">{error}</span>
        ) : (
          <Chart options={options} series={series} type="donut" height="100%" />
        )}
      </div>

      {!loading && !error && (
        <div className="mt-2" style={{ maxWidth: '250px', margin: '0 auto' }}>
          <h5 className="fw-semibold mb-4">Assets Capacity Usage</h5>
          <p>Available: {availableAssetsCount}</p>
          <p>Assigned: {assignedAssetsCount}</p>
        </div>
      )}
    </div>
  );
};

export default AssetsChart;
